var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "page-tab withdraw-info-container",
      staticStyle: { height: "600px" },
    },
    [
      _c("SchemaTablePage", {
        ref: "tablePageRef",
        attrs: {
          "form-props": { labelPosition: "left" },
          "layout-mode": "dialog",
          immediate: false,
          "search-schema": _vm.searchSchema,
          "default-query": _vm.defaultQuery,
          request: _vm.request,
          "build-params": _vm.buildParams,
          "parse-result": _vm.parseResult,
        },
        scopedSlots: _vm._u([
          {
            key: "table-content",
            fn: function ({ tableProps, tableData, loading }) {
              return [
                _c(
                  "el-table",
                  _vm._b(
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: loading,
                          expression: "loading",
                        },
                      ],
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: tableData,
                        size: "small",
                        border: "",
                        stripe: "",
                        fit: "",
                        "highlight-current-row": "",
                        "summary-method": _vm.getSummaries,
                        "show-summary": "",
                      },
                    },
                    "el-table",
                    tableProps,
                    false
                  ),
                  [
                    _c("el-table-column", {
                      attrs: {
                        resizable: false,
                        prop: "orderNo",
                        label: "订单号",
                        "min-width": "180",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        resizable: false,
                        prop: "thirdOrderNo",
                        label: "三方订单号",
                        "min-width": "180",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        resizable: false,
                        prop: "orderAmount",
                        label: "订单金额",
                        width: "100",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("centsToYuan")(
                                        scope.row.orderAmount
                                      )
                                    )
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        resizable: false,
                        prop: "accountType",
                        label: "账号类型",
                        width: "110",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        resizable: false,
                        prop: "bankName",
                        label: "银行名称",
                        "min-width": "150",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        resizable: false,
                        prop: "account",
                        label: "提款账号",
                        "min-width": "120",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        resizable: false,
                        prop: "paymentChannelName",
                        label: "代付通道",
                        width: "110",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        resizable: false,
                        prop: "applyTime",
                        label: "申请时间",
                        width: "150",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        resizable: false,
                        prop: "completeTime",
                        label: "完成时间",
                        width: "150",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        resizable: false,
                        fixed: "right",
                        prop: "status",
                        label: "订单状态",
                        width: "100",
                        align: "center",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      size: "mini",
                                      type: _vm.getTagType(scope.row.status)
                                        ?.type,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getTagType(scope.row.status)?.label
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }